import React, { useEffect, useState } from "react";
import "./relevantsetmoadl.css";
import { Box, Grow, Modal } from "@mui/material";
import LongCard from "../LongCard/LongCard";
import { transformDataForCreateOrderPage } from "utils/transformdata";
import { getIcon } from "utils/iconsConfig";

function RelevantSetModal({ selectedRelevantDesigns, openModal, handleClose, cartDesigns, updateChanges }) {
  const [releventDesigns, setReleventDesigns] = useState([]);

  useEffect(() => {
    if (openModal) {
      const filtered = cartDesigns.filter((item) => selectedRelevantDesigns.includes(item.styleNumber.toString()));
      setReleventDesigns(filtered);
    }
  }, [openModal]);

  const handleRemoveRelevantDesign = (designToBeRemmove) => {
    const styleNumber = designToBeRemmove.styleNumber.toString();
    const removed = JSON.parse(sessionStorage.getItem("TempRemovedModalDesigns")) || [];
    if (!removed.includes(styleNumber)) {
      removed.push(styleNumber);
      sessionStorage.setItem("TempRemovedModalDesigns", JSON.stringify(removed));
    }
    setReleventDesigns((prev) => prev.filter((item) => item.styleNumber !== styleNumber));
  };

  const handleUpdateDesign = (updatedDesign) => {
    setReleventDesigns((prev) => prev.map((item) => (item.styleNumber === updatedDesign.styleNumber ? updatedDesign : item)));
  };

  return (
    <Modal open={openModal} onClose={handleClose} sx={{ display: "flex", justifyContent: "center" }}>
      <Grow in={openModal}>
        <Box className="relevantset-modal-body" sx={{ display: "flex", flexDirection: "column" }}>
          <Box sx={{ textAlign: "end", padding: "0.7vw", cursor: "pointer" }} onClick={() => handleClose()}>
            {getIcon(`BoxCrossIcon`)}
          </Box>
          <Box marginX="auto" className="relevantDesignPart">
            {Array.isArray(releventDesigns) && releventDesigns.length > 0 ? (
              releventDesigns.map((item) => {
                const sizeData = item?.sizeData;
                const relevantDesign = transformDataForCreateOrderPage(item);
                return (
                  <LongCard
                    key={relevantDesign.styleNumber}
                    data={relevantDesign}
                    handleClose={handleClose}
                    setIcon={false}
                    RemoveDesign={handleRemoveRelevantDesign}
                    onUpdate={handleUpdateDesign}
                    fromModal={true}
                    sizeData={sizeData}
                  />
                );
              })
            ) : (
              <Box
                sx={{
                  color: "#888",
                  fontSize: "1vw",
                  textAlign: "center",
                  padding: "2vw",
                  fontFamily: "Poppins",
                }}
              >
                No Relevant Designs are present.
              </Box>
            )}
          </Box>
          <Box className="apply-btn" onClick={() => updateChanges(releventDesigns)}>
            Apply
          </Box>
        </Box>
      </Grow>
    </Modal>
  );
}

export default RelevantSetModal;
